import { render } from "./TheLegalLayout.vue?vue&type=template&id=65a97c64&scoped=true"
import script from "./TheLegalLayout.vue?vue&type=script&lang=js"
export * from "./TheLegalLayout.vue?vue&type=script&lang=js"

import "./TheLegalLayout.vue?vue&type=style&index=0&id=65a97c64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a97c64"]])

export default __exports__